"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildIframeSource = void 0;
// The HTML5 Advert needs to know the parent frame origin
// for secure cross-frame messaging.
const buildIframeSource = (source, placement) => {
    const url = new URL(window.location.href);
    const glue = source.match(/\?/) ? '&' : '?';
    return `${source}${glue}_origin=${url.origin}&_placement=${placement}`;
};
exports.buildIframeSource = buildIframeSource;
//# sourceMappingURL=iframe.util.js.map